import { OptimizelyLongString, ImageReference, OptimizelyXhtmlString, OptimizelyBoolean, OptimizelyDate } from "..";
import { OptimizelyBlockExpandedValue } from "../expanded";

interface ImagePosition extends OptimizelyLongString {
    value: "Right" | "Left";
}

export interface TextImageBlockData extends OptimizelyBlockExpandedValue {
    contentType: ["Block", "TextImageBlock"];
    title: OptimizelyLongString;
    backgroundColor: OptimizelyLongString;
    fontColor: OptimizelyLongString;
    image: ImageReference;
    imagePosition: ImagePosition;
    textEditor: OptimizelyXhtmlString;
    anchorId?: OptimizelyLongString;
    expirationDate?: OptimizelyDate;
    buttonEnabled?: OptimizelyBoolean;
}

export const isTextImageBlockData = (
    block: OptimizelyBlockExpandedValue
): block is TextImageBlockData => {
    return block.contentType[1] === "TextImageBlock";
};